// components/atoms/PushPromptModal.tsx
import * as React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Stack,
} from '@mui/material';

type Props = {
  open: boolean;
  onClose: () => void;
  onEnable: () => void;
};

export const PushPromptModal: React.FC<Props> = ({
  open,
  onClose,
  onEnable,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="xs"
    fullWidth
    sx={{
      '& .MuiDialog-paper': { borderRadius: 3, p: 2 },
    }}
  >
    <DialogTitle>
      <Typography variant="h6" component="span">
        {'Enable Push Notifications'}
      </Typography>
    </DialogTitle>

    <DialogContent dividers>
      <Typography variant="body1">
        {
          'This application can send you notifications. Enable push notifications to stay updated.'
        }
      </Typography>
    </DialogContent>

    <DialogActions>
      <Stack direction="row" spacing={1} sx={{ px: 1, pb: 1 }}>
        <Button variant="outlined" onClick={onClose}>
          {'Cancel'}
        </Button>
        <Button variant="contained" onClick={onEnable}>
          {'Enable push'}
        </Button>
      </Stack>
    </DialogActions>
  </Dialog>
);
export default PushPromptModal;
